import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RouteAction } from '@core/action/action';
import { MessageService } from '@core/services/message.service';
import { MovimentacaoSocietariaService } from '@core/services/movimentacao-societaria.service';
import { VinculoService } from '@core/services/vinculo.service';
import { ColumnOrder } from '@core/table/order';
import { MovimentacaoSocietariaMudancaSocietariaComponent } from '@modules/movimentacao-societaria/pages/movimentacao-societaria-mudanca-societaria/movimentacao-societaria-mudanca-societaria.component';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import { NzModalService, ModalOptions } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-movimentacao-societaria-tabela',
  templateUrl: './movimentacao-societaria-tabela.component.html',
  styleUrls: ['./movimentacao-societaria-tabela.component.scss']
})
export class MovimentacaoSocietariaTabelaComponent implements AfterViewInit, OnChanges {

  @Output() atualizarTabelaMovimentacao = new EventEmitter<any>();
  @Input() pessoa: any;
  @Input() entidade: any;
  @Input() form!: FormGroup;

  @Input() somenteVisualizar!: any;

  dataSet: any[] = [];
  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;
  columOrder: ColumnOrder | undefined;

  constructor(
    private modalService: NzModalService,
    private messageService: MessageService,
    private movimentacaoSocietariaService: MovimentacaoSocietariaService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.buscarDados();
  }

  ngAfterViewInit(): void {
    this.paginator.change.subscribe((val) => {
      this.buscarDados();
    })
  }

  buscarDados(): void {
    const filtro = this.pessoa ? { pessoa: this.pessoa?.id } : { entidadeId: this.entidade?.id };

    if (this.paginator) {
    this.paginator.reset();
    }
    this.consultar(filtro);
  }

  consultar(filtro: any): void {
    if(!this.entidade?.id) {
      return;
    }
    this.movimentacaoSocietariaService.consultarIdDaEntidade(this.entidade.id, this.paginator?.pagination).subscribe((data: any) => {
      this.dataSet = data.content;
      this.paginator.totalItens = data.totalElements;
    });
  }

  remover(item: any) {
    console.log(item);
    if (item.id) {
      // this.vinculoService.remover(item.id).subscribe(() => {
      //   this.messageService.success('Vínculo excluído com sucesso!');
      //   this.buscarDados();
      // });
    }
  }

  editar(obj: any) {
    this.showModal(obj);
  }

  novo() {
    this.showModal();
  }

  esconderBotaoRemover(item: any): boolean {
    return !item.id;
  }

  editarMovimentacaoSocietaria(obj?: any) {
    this.showModal(obj);
  }

  showModal(obj?: any): void {
    const config: ModalOptions<MovimentacaoSocietariaMudancaSocietariaComponent> = {
      // nzTitle: 'Vinculo:',
      nzContent: MovimentacaoSocietariaMudancaSocietariaComponent,
      nzCentered: true,
      nzFooter: null,
      nzMaskClosable: false,
      nzWidth: '60vw',
      nzClosable: false,
      nzClassName: 'modal-vinculo',
    };

    const elementFooterBtnsAcao = document.getElementById('footer-btns-fixed');
    if (elementFooterBtnsAcao) {
      elementFooterBtnsAcao.classList.remove('footer-btns-fixed');
    }

    const modalRef = this.modalService.create(config);
    modalRef.componentInstance!.acao = obj ? RouteAction.Editar : RouteAction.Inserir;
    modalRef.componentInstance!.isModal = true;
    console.log(this.entidade);
    modalRef.componentInstance!.idEntidade = this.entidade ? this.entidade?.id : null;
    modalRef.componentInstance!.entidade = this.entidade ? this.entidade : null;

    modalRef.componentInstance!.obj = obj;
    modalRef.componentInstance!.form = this.form;

    modalRef.afterClose.subscribe((res) => {
      this.buscarDados();

      this.atualizarTabelaMovimentacao.emit(true);
      if(res?.razaoSocial) {
      }

      if (elementFooterBtnsAcao) {
        elementFooterBtnsAcao.classList.add('footer-btns-fixed');
      }
    });
  }

  sort(event: any) {
    const itemSelected = event.sort.find((x: any) => x.value);
    const sortField = itemSelected?.key;
    const sortOrder = itemSelected?.value;

    const sortParams = {
      sortField,
      sortOrder
    };

    if(sortField && sortOrder) {
      this.loadData(sortParams);
    }
  }

  loadData(sortParams?: any): void {
    let params = {};
    if (sortParams) {
      params = { ...sortParams };
    }

    if(!this.entidade?.id) {
      return;
    }

    this.movimentacaoSocietariaService.consultarSortIdDaEntidade(this.entidade.id, this.paginator.pagination, params).subscribe((data) => {
      this.dataSet = data.content;
      this.paginator.totalItens = data.totalElements;
    });
  }
}
